import React, { useEffect, useState } from 'react'
import './css/AssignProject.css'
import { url } from '../../constants/url'
import { useAuth } from '../../Context/UserContext'
import { toast } from 'react-toastify'

const AssignProject = (props) => {

    const {
        assignSidebar, setAssignSidebar, projectId, setProjectId, projects, leadId, setLeadId,
        developerSuggestions, leadNameError, projectNameError, handleAddTeamLead, who, setDevelopersSuggestions,
        developersSuggestions, developer, setDeveloper, dueDate, setDueDate, handleDeveloperAssign
    } = props



    const { logout } = useAuth()


    if (!assignSidebar) {
        return null;
    }

    return (
        <div
            className='assign-project-container'
            onClick={() => setAssignSidebar(false)}>
            <div
                className='assign-project-side-bar'
                onClick={e => e.stopPropagation()}>
                <div className='assign-project-side-bar-header' >
                    {
                        who && who === "vulnerabilities" ? (<h2 style={{ marginTop: '-15px', fontSize:'18px' }}>Assign a vulnerability</h2>) : (<h2 style={{ marginTop: '-15px', fontSize:'18px' }}>Assign a project</h2>)
                    }
                    <button style={{ marginBottom: '15px' }} onClick={() => setAssignSidebar(false)}>X</button>
                </div>
                <div className='assign-project-side-bar-content'>

                    <div className='assign-project-side-bar-form'>
                        {who && who === "vulnerabilities" ? (
                            <>
                                <label>Engineer Name</label>
                                <select
                                    value={developer}
                                    onChange={(e) => setDeveloper(e.target.value)}>
                                    <option value="">--Select--</option>
                                    {developersSuggestions?.map((user, index) => (
                                        <option key={index} value={user.id}>
                                            {user.name}
                                        </option>
                                    ))}
                                </select>
                            </>
                        ) : (
                            <>
                                <label>Project Name</label>
                                <select value={projectId}
                                    onChange={(e) => setProjectId(e.target.value)}>
                                    <option value="">--Select--</option>
                                    {projects.map((project, index) => (
                                        <option key={index} value={project._id}>
                                            {project.projectName}
                                        </option>
                                    ))}
                                </select>
                                {leadNameError && <p>{leadNameError}</p>}
                            </>
                        )}

                    </div>
                    <div className='assign-project-side-bar-form'>
                        {who && who === "vulnerabilities" ? (
                            <>
                                <label>Due Date</label>
                                <input
                                    type="date"
                                    placeholder='Enter due date'
                                    value={dueDate}
                                    onChange={(e) => setDueDate(e.target.value)}
                                />
                            </>) : (
                            <>
                                <label>Team Lead Name</label>
                                <select
                                    value={leadId}
                                    onChange={(e) => setLeadId(e.target.value)}>
                                    <option>--Select--</option>
                                    {Array.isArray(developerSuggestions) && developerSuggestions.map((user, index) => (
                                        <option key={index} value={user.id}>
                                            {user.name}
                                        </option>
                                    ))}
                                </select>
                                {projectNameError && <p>{projectNameError}</p>}
                            </>)}


                    </div>
                    <div className='assign-project-side-bar-form'>

                    </div>
                    <div className='assign-project-side-bar-assign-btn'>
                        {who && who === "vulnerabilities" ? (
                            <button type='submit' onClick={handleDeveloperAssign}>Assign Project</button>
                        ) : (
                            <button type='submit' onClick={handleAddTeamLead}>Assign Project</button>
                        )}

                    </div>

                </div>
            </div>
        </div>
    )
}

export default AssignProject